namespace Matrix.Rebalancer {
    export class TaskTypePropertiesColumns {
        static columnsKey = 'Rebalancer.TaskTypeProperties';
    }
}
